import { animateScroll as scroll, Link } from "react-scroll";

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="side1">
            <div className="row">
              <div className="col-md-3">
                <h1 className="logo">MP-Tech Piotr Mętel</h1>
                <p className="footer-text">Roboty ziemne i przygotowanie terenu pod budowę</p>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Linki</p>
                <ul>
                  <li>
                    <Link spy={true} smooth={true} duration={1000} to="headerbg">
                      {" "}
                      Główna{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="services" spy={true} smooth={true} duration={1000}>
                      {" "}
                      Usługi{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="about-scroll" spy={true} smooth={true} duration={1000}>
                      O Nas{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="contact" spy={true} smooth={true} duration={1000}>
                      {" "}
                      Kontakt{" "}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="side2">
            <div className="row">
              <div className="col-md-3">
                <p className="footer-title">Kontakt</p>
                <ul>
                  <li>
                    <Link to="#">MP-Tech Piotr Mętel</Link>
                  </li>
                  <li>
                    <Link to="#">Franciszkańska 3/35 16-400 Suwałki</Link>
                  </li>
                  <li>
                    <Link to="#">+48 606 313 180</Link>
                  </li>
                  <li>
                    <Link to="#">mp.tech@yahoo.com</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Social Media</p>
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/profile.php?id=61565404209832"
                    >
                      {" "}
                      Facebook
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button onClick={() => scroll.scrollToTop(2500)} src="" className="gotop">
        <i className="fas fa-level-up-alt"></i>
      </button>
    </footer>
  );
}
export default Footer;
